// extracted by mini-css-extract-plugin
module.exports = {"main":"eEF5uuMw","title":"prt5QPxK"};